import { OOOrderTypeDeliveryZone } from "./oo-order-type-delivery-zone";
import { OOOrderTypeField } from "./oo-order-type-field";
import { OOOrderTypeThrottle } from "./oo-order-type-throttle";

export class OOOrderType {
	key?: number;
	venueKey: number;
	posName?: string;
	displayName?: string;
	tipped?: boolean;
	tippedCustom?: boolean;
	tip1?: number;
	tip2?: number;
	tip3?: number;
	payAtStore?: boolean;
	payCreditCard?: boolean;
	payGift?: boolean;
	payGiftRequireCC?: boolean;
	promptAddress?: boolean;
	requireEmail?: boolean;
	OOOrderTypeDeliveryZone?: OOOrderTypeDeliveryZone[];
	ooOrderTypeFields?: OOOrderTypeField[];
	ooOrderTypeThrottles?: OOOrderTypeThrottle[];
	instructions?: string;
	checkLeaveOpenMinutes?: number;
	smsBeforeCloseMinutes?: number;
	autoCloseCheck?: boolean;
	active?: boolean;
	atTable?: boolean;
	futureOrders?: boolean;
	ccAdminEmailOnOrder?: boolean;
	deleted?: boolean;
	throttle?: boolean;
	throttleSampleMinutes?: number;
	ignoreOOEnabledTime?: boolean;
	minimumOrderAmount?: number;
	maximumOrderAmount?: number;
	deliveryZone?: string;
	outOfDeliveryZoneMessage?: string;
	useLinkKeyTable?: boolean;
	includeGuestNameOnOrder?: boolean;
	includeNameFormat?: number;
	includeNamePrefix?: number;
	orderLeadTime?: number;
	kiosk: boolean;
	identifierName: string;
	identifierNameOptions: string[];
	checkoutReceiptStyle: number;
	storeCustomerData?: boolean;
	orderTypeNote: string;

	identifierInputType: number;

	inactive: boolean;

	public constructor(init?: Partial<OOOrderType>) {
		Object.assign(this, init);
	}
}

export class LatLng {
	lat: number;
	lng: number;

	public constructor(init?: Partial<LatLng>) {
		Object.assign(this, init);
	}
}

export class OrderTypeOrderIdentifier {
	name: string;
	created: string;
	unsaved?: boolean;

	public constructor(init?: Partial<OrderTypeOrderIdentifier>) {
		Object.assign(this, init);
	}
}
